import { render, staticRenderFns } from "./like-dialog.vue?vue&type=template&id=19fe34cf&scoped=true"
import script from "./like-dialog.vue?vue&type=script&lang=js"
export * from "./like-dialog.vue?vue&type=script&lang=js"
import style0 from "./like-dialog.vue?vue&type=style&index=0&id=19fe34cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe34cf",
  null
  
)

export default component.exports